import { useAllVoices } from '@/hooks/useAllVoices';
import { getLanguageFlagSrc } from '@/utils/getLangaugeFlagSrc';
import { Providers } from '@d-id/types';
import { useMemo } from 'react';

export interface IVoiceLanguage {
    label: string;
    locale: string;
    flagSrc: string | null;
}

export const useVoicesLanguages = (): IVoiceLanguage[] => {
    const { data = [] } = useAllVoices();

    const languagesArray = useMemo(() => {
        const array = data
            .filter(voice => voice.provider !== Providers.Amazon && !!voice.language)
            .map(voice => ({
                label: voice.language,
                locale: voice.locale,
                flagSrc: getLanguageFlagSrc(voice),
            }))
            // Exclude labels with "(XX)" at the end
            .filter(voice => !/\([A-Z]{2,}\)$/.test(voice.label))
            .sort((a, b) => a.label.localeCompare(b.label)) as IVoiceLanguage[];

        const map = new Map();

        array.forEach(voice => map.set(voice.locale, voice));

        return Array.from(map.values());
    }, [data]);

    return languagesArray;
};
